module.exports = __webpack_public_path__ + "img/ic-sel-filter.90a99743.svg";